import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount || 0);
}

export function getStatusBadgeClass(status) {
  switch (status) {
    case 'pending':
      return 'badge-warning';
    case 'approved':
      return 'badge-success';
    case 'rejected':
      return 'badge-error';
    case 'completed':
      return 'badge-brand';
    case 'new':
      return 'badge-brand';
    case 'contacted':
      return 'badge-warning';
    case 'done':
      return 'badge-success';
    default:
      return 'badge-brand';
  }
}

export function getStatusLabel(status) {
  const labels = {
    pending: 'En attente',
    approved: 'Acceptée',
    confirmed: 'Acompte payé',
    rejected: 'Refusée',
    completed: 'Terminée',
    cancelled: 'Annulée',
    new: 'Nouveau',
    contacted: 'Contacté',
    done: 'Traité',
  };
  return labels[status] || status;
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function generateWidgetCode(userId, type, baseUrl) {
  if (type === 'callback') {
    return `<!-- DigiTools - Widget Rappel -->
<div id="wp-modules-callback" data-user-id="${userId}"></div>
<script src="${baseUrl}/widgets/callback.js"></script>`;
  }
  
  if (type === 'tracking') {
    return `<!-- DigiTools - Tracking -->
<script>
  (function() {
    var s = document.createElement('script');
    s.src = '${baseUrl}/widgets/tracking.js';
    s.setAttribute('data-user-id', '${userId}');
    document.head.appendChild(s);
  })();
</script>`;
  }
  
  return '';
}
